module.exports = __webpack_public_path__ + "static/images/components/UpgradeIcon/images/arrow-base.20811f74.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeIcon/images/arrow-base.png
// module id = 2700
// module chunks = 11